import type { ReactNode } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import {
  AiInsightsIcon,
  LogoutIcon,
  ProfileIcon,
  SupportHeaderIcon,
} from '@/assets/icons/icons';

export type LocalMenuActionKey =
  'aiInsightsChat' | 'help' | 'profile' | 'logout';

export type LocalMenuAction = {
  key: LocalMenuActionKey;
  route: string;
  label: string;
  icon: ReactNode;
  onClick: () => void;
};

interface BuildLocalActionsParams {
  closeFloatingDropdowns: () => void;
  logoutCall: () => void | Promise<void>;
  navigate: NavigateFunction;
  onHelpOpenChange: (open: boolean) => void;
  onOpenAiInsights: () => void;
  showAiInsightsChat: boolean;
}

export function buildLocalActions({
  closeFloatingDropdowns,
  logoutCall,
  navigate,
  onHelpOpenChange,
  onOpenAiInsights,
  showAiInsightsChat,
}: BuildLocalActionsParams): LocalMenuAction[] {
  return [
    ...(showAiInsightsChat
      ? [
          {
            key: 'aiInsightsChat' as const,
            route: 'ai-insights-chat',
            label: 'AI Insights chat',
            icon: (
              <AiInsightsIcon width={20} height={20} color='currentColor' />
            ),
            onClick: onOpenAiInsights,
          },
        ]
      : []),
    {
      key: 'help',
      route: 'help',
      label: 'Get help',
      icon: <SupportHeaderIcon width={22} height={22} />,
      onClick: () => {
        onHelpOpenChange(true);
      },
    },
    {
      key: 'profile',
      route: 'profile',
      label: 'Profile',
      icon: <ProfileIcon width={20} height={20} fill='currentColor' />,
      onClick: () => {
        closeFloatingDropdowns();
        navigate('/settings/profile', {
          state: { mobileMenuActive: 'profile' },
        });
      },
    },
    {
      key: 'logout',
      route: 'logout',
      label: 'Logout',
      icon: <LogoutIcon width={20} height={20} fill='currentColor' />,
      onClick: () => {
        closeFloatingDropdowns();
        logoutCall();
      },
    },
  ];
}
